import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';

class TutorialView extends React.Component {

    clickFind() {
        this.props.clickFind(this.state.name || this.props.defaultName);
    }

    clickCustom() {
        this.props.clickCustom(this.state.name || this.props.defaultName);
    }

	render() {
        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header/>

                <div class="middle" id="nickname">
                    <h3>
                        Would you like a tutorial on how to play?
                        <br/><br/><br/>
                        <button onClick={this.props.clickYes} id="go">View Tutorial</button>
                        <div class="vPadding"></div>
                        <button onClick={this.props.clickNo} class="button2">Skip</button>
                    </h3>
                    <div class="tutorialPrivacyPopup">
                        By playing this game you agree to our <a href="https://traitors.sh/resources/privacy.html" target="_blank">Privacy Policy</a> and <a href="https://traitors.sh/resources/termsofservice.html" target="_blank">Terms of Service</a>
                    </div>
                </div>

                <Footer clickPrivacySettings={this.props.clickPrivacySettings} clickLeaders={this.props.clickLeaders}/>
            </div>
        );
	}
}

TutorialView.propTypes = {
  clickYes: PropTypes.func,
  clickNo: PropTypes.func,
};

export default TutorialView;